import React from 'react';

// Unified brand icon treatment: rounded-square teal-50 tile, teal-900 line icon
const FILL = '#E1F5EE'; // teal 50
const LINE = '#085041'; // teal 900

export const BrandIcon = ({ icon: Icon, className = '', size = 'md', variant = 'teal' }) => {
  const dims =
    size === 'sm'
      ? { tile: 'w-12 h-12 rounded-xl', icon: 'w-6 h-6' }
      : { tile: 'w-16 h-16 rounded-2xl', icon: 'w-8 h-8' };
  const fill = variant === 'amber' ? '#FEF3E0' : FILL;
  const line = variant === 'amber' ? '#E0930A' : LINE;
  return (
    <div
      className={`inline-flex items-center justify-center ${dims.tile} ${className}`}
      style={{ backgroundColor: fill }}
    >
      <Icon className={dims.icon} style={{ color: line }} strokeWidth={2.5} />
    </div>
  );
};

export default BrandIcon;
